import { useState, useEffect } from "react";
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';

export default function useNewReleaseLineCharts(props: any) {
  const { data, tableSelection } = props;

  const [xLabel, setXLabel] = useState([]);
  const [seriesData, setSeriesData] = useState([]);
  const [legendSelected, setLegendSelected] = useState({});
  const [legendData, setLegendData] = useState<any[]>([]);

  // console.log('useNewReleaseLineCharts', data);

  const getCurGameInfo = (itemGame: any) => {
    return tableSelection?.find((item: any) => item.app_id == itemGame.app_id) || {};
  }

  const lineDataFormatter = (list: any) => {
    if (Array.isArray(list) && list?.length > 0) {
      let xLabel = list[0]?.time_line?.map((item: any) => item.date);
      let _legendSelected = {} as any;
      let _legendData: any[] = [];
      let series = list?.map((itemGame: any) => {
        const gameInfo = getCurGameInfo(itemGame);
        // 
        let _seriesName = gameInfo?.name;
        _legendSelected[`${_seriesName}`] = true;
        let _legendDataItem = {
          name: gameInfo?.name,
          icon: 'circle',
        }
        _legendData.push(_legendDataItem);
        return {
          name: gameInfo?.name,
          type: 'line',
          symbol: 'circle',
          data: itemGame.time_line?.map((item: any) => [item?.date, item?.value ? item?.value : 0]),
          cover: itemGame.cover,
        }
      })
      setXLabel(xLabel);
      setSeriesData(series);
      setLegendSelected({ ..._legendSelected });
      setLegendData(_legendData);
    }
  }

  // y轴label格式化
  const yAxisFormatter = (value: any) => {
    return `${mathFormat(value, true)}%`;
  }

  const legendsCustomMade = () => {
    return {
      type: 'scroll',
      orient: 'horizontal', //横向
      pageIconColor: '#000', //翻页箭头颜色
      // selectedMode: false,
      pageIconSize: 12,
      pageTextStyle: {
        color: '#000', //翻页数字颜色
      }, //翻页数字设置
      show: true,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      inactiveColor: '#ccc',//关闭时图例颜色
      inactiveBorderWidth: 0,
      inactiveBorderColor: '#ffffff',//默认存在#ccc，看起来会比设置的icon图例大小有区别
      borderWidth: 0,
      bottom: 0,
      left: 'center',
      textStyle: {
        color: '#888888',
        fontSize: 12,
      },
      data: [...legendData],
      selected: { ...legendSelected },
      itemGap: 20,
    };
  }

  useEffect(() => {
    lineDataFormatter(data)
  }, [data])

  return {
    seriesData: seriesData,
    xAxisData: xLabel,
    yAxisFormatter: yAxisFormatter,
    createLegendsCustomMade: legendsCustomMade(),
  };
}
